import React from 'react';

import { Skeleton } from '@material-ui/lab';

import BaseSkeleton from '../BaseSkeleton';
import Card from '../../../Card';

import { SocialCardSkeletonProps } from './SocialCardSkeleton.types';

const SocialCardSkeleton: React.FC<SocialCardSkeletonProps> = ({
  className,
  alignRight
}) => {
  return (
    <Card className={`flex flex-row p4 ${className} flex-start`}>
      {!alignRight && (<Skeleton variant="rect" height={50} width={100} className="br2" />)}
      <BaseSkeleton height={50} width={300} className="ml4" />
      {alignRight && (<Skeleton variant="rect" height={50} width={100} className="br2" />)}
    </Card>
  );
};

export default SocialCardSkeleton;
export { SocialCardSkeletonProps };
